var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// tslint:disable-next-line:no-useless-cast
var TAGS = ["clr", "clrEnd", "/clr", "fix", "/fix", "/format", "/color"];
export function splitStringToTokens(str) {
    var e_1, _a;
    var out = [];
    var pos = 0;
    var text = "";
    var flushText = function () {
        if (text.length > 0) {
            out.push({ type: "text", text: text });
            text = "";
        }
    };
    while (pos < str.length) {
        var simpleTagFound = false;
        try {
            for (var TAGS_1 = (e_1 = void 0, __values(TAGS)), TAGS_1_1 = TAGS_1.next(); !TAGS_1_1.done; TAGS_1_1 = TAGS_1.next()) {
                var candidate = TAGS_1_1.value;
                var candidateWithBrackes = "<" + candidate + ">";
                if (str.slice(pos, pos + candidateWithBrackes.length) === candidateWithBrackes) {
                    flushText();
                    out.push({ type: "tag", tag: candidate });
                    pos += candidateWithBrackes.length;
                    simpleTagFound = true;
                    continue;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (TAGS_1_1 && !TAGS_1_1.done && (_a = TAGS_1.return)) _a.call(TAGS_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (simpleTagFound) {
            continue;
        }
        var formatMatch = str.slice(pos).match(/^\<format=?(left|right|center)?,?(\d+)?\>/);
        if (formatMatch) {
            flushText();
            pos += formatMatch[0].length;
            var whereToPad = formatMatch[1] || undefined;
            var howManyPd = formatMatch[2] ? parseInt(formatMatch[2]) : undefined;
            out.push({
                type: "format",
                format: whereToPad !== undefined && howManyPd !== undefined
                    ? {
                        kind: whereToPad,
                        numberOfSpaces: howManyPd,
                    }
                    : undefined,
            });
            continue;
        }
        var colorMatch = str.slice(pos).match(/^\<color=?(\d+)?,?(\d+)?,?(\d+)?\>/);
        if (colorMatch) {
            flushText();
            pos += colorMatch[0].length;
            var r = colorMatch[1] ? parseInt(colorMatch[1]) : undefined;
            var g = colorMatch[2] ? parseInt(colorMatch[2]) : undefined;
            var b = colorMatch[3] ? parseInt(colorMatch[3]) : undefined;
            out.push({
                type: "color",
                color: r !== undefined && g !== undefined && b !== undefined ? { r: r, g: g, b: b } : undefined,
            });
            continue;
        }
        // And by default feeding text
        if (pos < str.length) {
            text = text + str[pos];
            pos++;
        }
    }
    flushText();
    return out;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVlc3RSZXBsYWNlVGFncy5zcGxpdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInF1ZXN0UmVwbGFjZVRhZ3Muc3BsaXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFjQSwyQ0FBMkM7QUFDM0MsSUFBTSxJQUFJLEdBQUcsQ0FBQyxLQUFLLEVBQUUsUUFBUSxFQUFFLE1BQU0sRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxRQUFRLENBQVUsQ0FBQztBQTRCcEYsTUFBTSxVQUFVLG1CQUFtQixDQUFDLEdBQVc7O0lBQzdDLElBQU0sR0FBRyxHQUFzQixFQUFFLENBQUM7SUFFbEMsSUFBSSxHQUFHLEdBQUcsQ0FBQyxDQUFDO0lBQ1osSUFBSSxJQUFJLEdBQUcsRUFBRSxDQUFDO0lBRWQsSUFBTSxTQUFTLEdBQUc7UUFDaEIsSUFBSSxJQUFJLENBQUMsTUFBTSxHQUFHLENBQUMsRUFBRTtZQUNuQixHQUFHLENBQUMsSUFBSSxDQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxJQUFJLE1BQUEsRUFBRSxDQUFDLENBQUM7WUFDakMsSUFBSSxHQUFHLEVBQUUsQ0FBQztTQUNYO0lBQ0gsQ0FBQyxDQUFDO0lBRUYsT0FBTyxHQUFHLEdBQUcsR0FBRyxDQUFDLE1BQU0sRUFBRTtRQUN2QixJQUFJLGNBQWMsR0FBRyxLQUFLLENBQUM7O1lBQzNCLEtBQXdCLElBQUEsd0JBQUEsU0FBQSxJQUFJLENBQUEsQ0FBQSwwQkFBQSw0Q0FBRTtnQkFBekIsSUFBTSxTQUFTLGlCQUFBO2dCQUNsQixJQUFNLG9CQUFvQixHQUFHLE1BQUksU0FBUyxNQUFHLENBQUM7Z0JBRTlDLElBQUksR0FBRyxDQUFDLEtBQUssQ0FBQyxHQUFHLEVBQUUsR0FBRyxHQUFHLG9CQUFvQixDQUFDLE1BQU0sQ0FBQyxLQUFLLG9CQUFvQixFQUFFO29CQUM5RSxTQUFTLEVBQUUsQ0FBQztvQkFDWixHQUFHLENBQUMsSUFBSSxDQUFDLEVBQUUsSUFBSSxFQUFFLEtBQUssRUFBRSxHQUFHLEVBQUUsU0FBUyxFQUFFLENBQUMsQ0FBQztvQkFDMUMsR0FBRyxJQUFJLG9CQUFvQixDQUFDLE1BQU0sQ0FBQztvQkFDbkMsY0FBYyxHQUFHLElBQUksQ0FBQztvQkFDdEIsU0FBUztpQkFDVjthQUNGOzs7Ozs7Ozs7UUFDRCxJQUFJLGNBQWMsRUFBRTtZQUNsQixTQUFTO1NBQ1Y7UUFFRCxJQUFNLFdBQVcsR0FBRyxHQUFHLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLEtBQUssQ0FBQywyQ0FBMkMsQ0FBQyxDQUFDO1FBQ3RGLElBQUksV0FBVyxFQUFFO1lBQ2YsU0FBUyxFQUFFLENBQUM7WUFFWixHQUFHLElBQUksV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQztZQUU3QixJQUFNLFVBQVUsR0FBRyxXQUFXLENBQUMsQ0FBQyxDQUFDLElBQUksU0FBUyxDQUFDO1lBQy9DLElBQU0sU0FBUyxHQUFHLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsUUFBUSxDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUM7WUFFeEUsR0FBRyxDQUFDLElBQUksQ0FBQztnQkFDUCxJQUFJLEVBQUUsUUFBUTtnQkFDZCxNQUFNLEVBQ0osVUFBVSxLQUFLLFNBQVMsSUFBSSxTQUFTLEtBQUssU0FBUztvQkFDakQsQ0FBQyxDQUFDO3dCQUNFLElBQUksRUFBRSxVQUFxQjt3QkFDM0IsY0FBYyxFQUFFLFNBQVM7cUJBQzFCO29CQUNILENBQUMsQ0FBQyxTQUFTO2FBQ2hCLENBQUMsQ0FBQztZQUVILFNBQVM7U0FDVjtRQUVELElBQU0sVUFBVSxHQUFHLEdBQUcsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUMsS0FBSyxDQUFDLG9DQUFvQyxDQUFDLENBQUM7UUFDOUUsSUFBSSxVQUFVLEVBQUU7WUFDZCxTQUFTLEVBQUUsQ0FBQztZQUVaLEdBQUcsSUFBSSxVQUFVLENBQUMsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDO1lBRTVCLElBQU0sQ0FBQyxHQUFHLFVBQVUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsUUFBUSxDQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUM7WUFDOUQsSUFBTSxDQUFDLEdBQUcsVUFBVSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsVUFBVSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQztZQUM5RCxJQUFNLENBQUMsR0FBRyxVQUFVLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDO1lBQzlELEdBQUcsQ0FBQyxJQUFJLENBQUM7Z0JBQ1AsSUFBSSxFQUFFLE9BQU87Z0JBQ2IsS0FBSyxFQUFFLENBQUMsS0FBSyxTQUFTLElBQUksQ0FBQyxLQUFLLFNBQVMsSUFBSSxDQUFDLEtBQUssU0FBUyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsR0FBQSxFQUFFLENBQUMsR0FBQSxFQUFFLENBQUMsR0FBQSxFQUFFLENBQUMsQ0FBQyxDQUFDLFNBQVM7YUFDdkYsQ0FBQyxDQUFDO1lBQ0gsU0FBUztTQUNWO1FBQ0QsOEJBQThCO1FBQzlCLElBQUksR0FBRyxHQUFHLEdBQUcsQ0FBQyxNQUFNLEVBQUU7WUFDcEIsSUFBSSxHQUFHLElBQUksR0FBRyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUM7WUFDdkIsR0FBRyxFQUFFLENBQUM7U0FDUDtLQUNGO0lBQ0QsU0FBUyxFQUFFLENBQUM7SUFFWixPQUFPLEdBQUcsQ0FBQztBQUNiLENBQUMifQ==